import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import axios from 'axios';
import dayjs from 'dayjs'
import { FORM_ERROR } from 'final-form';
import {
  USER_SIGN_IN,
  USER_SIGN_OUT,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  USERS_COLLECTION,
  UPDATE_USER_TABLE_FILTERS,
  FETCH_SITE_SUCCESS,
  FETCH_SITE_FAILURE,
  FETCHING_SITE,
  ANSWERS_COLLECTION,
  RECEIVE_ANSWERS,
  RECEIVE_USERS,
  RECEIVE_USER,
  RECEIVE_ADMINS,
  USER_ONLINE,
  USER_OFFLINE,
  TIME_FORMAT,
} from '../constants';

function receiveAdmins(admins) {
  return {
    type: RECEIVE_ADMINS,
    payload: {
      admins,
    },
  };
}

export function fetchAdmins() {
  return (dispatch) => {
    return firebase.firestore().collection('admins').get().then((querySnapshot) => {
      const admins = [];

      querySnapshot.forEach((doc) => {
        if (doc.data().isAdmin === true) {
          admins.push(doc.id);
        }
      });

      return dispatch(receiveAdmins(admins));
    })
  }
}

function userSignIn(email, uid) {
  return {
    type: USER_SIGN_IN,
    payload: {
      email,
      uid,
    },
  };
}

function userSignOut() {
  return {
    type: USER_SIGN_OUT,
  };
}

function receiveUser(userUID, userData) {
  return {
    type: RECEIVE_USER,
    payload: {
      userUID,
      userData
    }
  }
}

function fetchUser(userUID) {
  return (dispatch) => {
    return firebase.firestore().collection(USERS_COLLECTION).doc(userUID).get()
      .then(doc => {
        return dispatch(receiveUser(doc.id, doc.data()))
      })
  }
}

export function listenToAuthChanges() {
  return dispatch => firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      dispatch(userSignIn(user.email, user.uid));
      dispatch(fetchUser(user.uid))
    } else {
      dispatch(userSignOut());
    }
  }, (error) => {
    console.log(error)
  }, (error) => {
    console.log(error)
  })
}

export function signOut() {
  return () => firebase.auth().signOut();
}

export function deleteUser(userUID) {
  return (dispatch) => {
    return firebase.firestore().collection(USERS_COLLECTION).doc(userUID).delete()
      .then(() => {
        dispatch(fetchUsers())
      })
      .catch(() => {
        dispatch(fetchUsers())
      })
  }
}

function signUpSuccess() {
  return {
    type: SIGN_UP_SUCCESS,
  };
}

function signUpFailure(error) {
  return {
    type: SIGN_UP_FAILURE,
    payload: {
      error,
    },
  };
}

export function signUp(values) {
  return (dispatch) => {
    const {
      firstName,
      lastName,
      email,
      password,
      city,
      eventDay,
      group,
    } = values || {};


    return new Promise((resolve, reject) => {
      firebase.auth().createUserWithEmailAndPassword(email, password)
        .then((user) => {
          console.log(user.user)
          return user.user.uid;
        })
        .catch((error) => {
          const errorCode = error.code;
          console.log(errorCode)
          switch (errorCode) {
            case "auth/email-already-in-use":
            case "auth/operation-not-allowed":
            case "auth/invalid-email":
            case "auth/weak-password":
            default:
              break;
          }
        })
        .then(uid => {
          console.log(uid)
          return firebase.firestore().collection(USERS_COLLECTION).doc(uid).set({
            firstName,
            lastName,
            city,
            eventDay,
            group,
            email,
          }).then(() => {
            return uid;
          }).catch(err => {
            console.log(err)
            return uid;
          })
        })
        .then((uid) => {
          dispatch(signUpSuccess())
          resolve(uid)
        })
        .catch((err) => {
          dispatch(signUpFailure(err))
          resolve({[FORM_ERROR]: 'Invalid Sign Up.'})
        })
        .then(reject());
    });
  };
}

function receiveAnswers(answers) {
  return {
    type: RECEIVE_ANSWERS,
    payload: {
      answers,
    },
  };
}

export function watchAnswers() {
  return (dispatch) => {
    return firebase.firestore().collection(ANSWERS_COLLECTION).get().then((querySnapshot) => {
      const answers = {};

      querySnapshot.forEach((doc) => {
        if (doc.metadata.hasPendingWrites) {
          return;
        }
        answers[doc.id] = doc.data();
      });

      return dispatch(receiveAnswers(answers));
    })

  };
}

function receiveUsers(users) {
  return {
    type: RECEIVE_USERS,
    payload: {
      users,
    },
  };
}

export function fetchUsers() {
  return (dispatch) => {
    return firebase.firestore().collection(USERS_COLLECTION).get()
      .then((querySnapshot) => {
        const users = {};
        querySnapshot.forEach((doc) => {
          users[doc.id] = doc.data();
          users[doc.id].eventDay = dayjs(parseInt(users[doc.id].eventDay, 10)).format(TIME_FORMAT)
        });

        return dispatch(receiveUsers(users));
      });
  };
}

export function updateUserTableFilters(values) {
  const {
    search,
    city,
    group,
    eventDay,
  } = values || {
    search: '',
    city: '',
    group: '',
    eventDay: '',
  };

  return {
    type: UPDATE_USER_TABLE_FILTERS,
    payload: {
      filters: {
        search,
        city,
        group,
        eventDay,
      },
    },
  };
}

function fetchingSite() {
  return {
    type: FETCHING_SITE,
  };
}

function fetchSiteSuccess(siteData) {
  return {
    type: FETCH_SITE_SUCCESS,
    payload: {
      siteData,
    },
  };
}

function fetchSiteFailure() {
  return {
    type: FETCH_SITE_FAILURE,
  };
}

export const fetchSite = () => (dispatch) => {
  dispatch(fetchingSite());
  return axios({
    url: 'https://us-central1-automotive-events-quiz.cloudfunctions.net/site',
  })
    .then(response => dispatch(fetchSiteSuccess(response.data)))
    .catch(() => dispatch(fetchSiteFailure()));
};


export function userOffline(timestamp) {
  return {
    type: USER_OFFLINE,
    payload: {
      timestamp,
    },
  };
}

export function userOnline(timestamp) {
  return {
    type: USER_ONLINE,
    payload: {
      timestamp,
    },
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js